import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CashbackBranchRatioEntity } from '../../domain/entities/CashbackBranchRatioEntity'

export class CashbackBranchRatioModel extends CashbackBranchRatioEntity {
  declare branchId: number

  constructor(dataDto: CashbackBranchRatioEntity) {
    super()
    mapEntityProperties<CashbackBranchRatioEntity>(this, dataDto)
  }
}
